module.exports = __webpack_public_path__ + "assets/checked-a10d15.svg";